<template>
    <div class="content">
      <div class="block mb-3">
        <div class="block-header">
          <h3 class="block-title"><font-awesome-icon icon="file-contract" /> {{ $t('app.debt_information') }}</h3>
          <div class="block-options">
              <button class="btn btn-sm btn-alt-primary" v-if="!editDebt" @click.prevent="handleEditDebt()">
                <i class="fa fa-edit"></i> {{ $t('buttons.edit') }}
              </button>
              <button class="btn btn-sm btn-alt-danger" v-if="editDebt" @click.prevent="handleEditDebt()">
                <i class="fa fa-times"></i> {{ $t('buttons.cancel') }}
              </button>
          </div>
        </div>
        <div class="block-content">
          <form @submit.stop.prevent="updateDebt">
            <div class="form-group row">
              <div class="col">
                <label for="UpdateNumber" class="col-form-label">{{ $t('debts.number') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.number" :class="{'is-invalid': errors.number }" id="UpdateNumber" :readonly="!editDebt">
                <span v-if="errors.number" class="invalid-feedback">
                    <strong>{{errors.number ? errors.number[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="UpdateStartDate" class="col-form-label">{{ $t('debts.start_date') }}</label>
                <input type="date" class="form-control" v-model="adminDebt.start_date" :class="{'is-invalid': errors.start_date }" id="UpdateStartDate" :readonly="!editDebt">
                <span v-if="errors.start_date" class="invalid-feedback">
                    <strong>{{ errors.start_date ? errors.start_date[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="UpdateEndDate" class="col-form-label">{{ $t('debts.end_date') }}</label>
                <input type="date" class="form-control" v-model="adminDebt.end_date" :class="{'is-invalid': errors.end_date }" id="UpdateEndDate" :readonly="!editDebt">
                <span v-if="errors.end_date" class="invalid-feedback">
                    <strong>{{ errors.end_date ? errors.end_date[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <label for="UpdateCurrentArrears" class="col-form-label">{{ $t('debts.current_arrears') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.current_arrears" :class="{'is-invalid': errors.current_arrears }" id="UpdateCurrentArrears" :readonly="!editDebt">
                <span v-if="errors.current_arrears" class="invalid-feedback">
                    <strong>{{ errors.current_arrears ? errors.current_arrears[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="UpdateLoadCurrentArrears" class="col-form-label">{{ $t('debts.loading_current_arrears') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.loading_current_arrears" :class="{'is-invalid': errors.loading_current_arrears }" id="UpdateLoadCurrentArrears" :readonly="!editDebt">
                <span v-if="errors.loading_current_arrears" class="invalid-feedback">
                    <strong>{{ errors.loading_current_arrears ? errors.loading_current_arrears[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <label for="UpdateMainDebt" class="col-form-label">{{ $t('debts.amount_main_debt') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.amount_main_debt" :class="{'is-invalid': errors.amount_main_debt }" id="UpdateMainDebt" :readonly="!editDebt">
                <span v-if="errors.amount_main_debt" class="invalid-feedback">
                    <strong>{{ errors.amount_main_debt ? errors.amount_main_debt[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="UpdateAmountCreditDate" class="col-form-label">{{ $t('debts.amount_credit') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.amount_credit" :class="{'is-invalid': errors.amount_credit }" id="UpdateAmountCreditDate" :readonly="!editDebt">
                <span v-if="errors.amount_credit" class="invalid-feedback">
                    <strong>{{ errors.amount_credit ? errors.amount_credit[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <label for="updateStatus" class="col-form-label">{{ $t('debts.status.name') }}</label>
                <select v-model="adminDebt.status_id" class="form-control" id="updateStatus" :disabled="!editDebt">
                  <option v-for="status in adminListDebtStatuses" :value="status.id">
                    {{ status.name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <label for="updateUserId" class="col-form-label">{{ $t('users.user') }}</label>
                <select v-model="adminDebt.user_id" class="form-control" id="updateUserId" :class="{'is-invalid': errors.user_id }" :disabled="!editDebt">
                  <option v-for="user in adminListUsers" :value="user.id">
                    {{ user.fullname }}
                  </option>
                </select>
                <span v-if="errors.user_id" class="invalid-feedback">
                    <strong>{{ errors.user_id ? errors.user_id[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="updateContragent" class="col-form-label">{{ $t('debts.contragent') }}</label>
                <select v-model="adminDebt.contragent_id" class="form-control" id="updateContragent" :disabled="!editDebt">
                  <option v-for="contragent in adminListContragents" :value="contragent.id">
                    {{ contragent.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <label for="UpdateAmountFine" class="col-form-label">{{ $t('debts.amount_fine') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.amount_fine" :class="{'is-invalid': errors.amount_fine }" id="UpdateAmountFine" :readonly="!editDebt">
                <span v-if="errors.amount_fine" class="invalid-feedback">
                    <strong>{{ errors.amount_fine ? errors.amount_fine[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="StoreReward" class="col-form-label">{{ $t('debts.amount_rewards') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.amount_rewards" :class="{'is-invalid': errors.amount_rewards }" id="StoreReward" :readonly="!editDebt">
                <span v-if="errors.amount_rewards" class="invalid-feedback">
                    <strong>{{ errors.amount_rewards ? errors.amount_rewards[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <label for="updateFilial" class="col-form-label">{{ $t('debts.filial') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.filial" :class="{'is-invalid': errors.filial }" id="updateFilial" :readonly="!editDebt">
                <span v-if="errors.filial" class="invalid-feedback">
                    <strong>{{ errors.filial ? errors.filial[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="updateProductName" class="col-form-label">{{ $t('debts.product_name') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.product_name" :class="{'is-invalid': errors.product_name }" id="updateProductName" :readonly="!editDebt">
                <span v-if="errors.product_name" class="invalid-feedback">
                    <strong>{{ errors.product_name ? errors.product_name[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <label for="updateCategoryDay" class="col-form-label">{{ $t('debts.category_day') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.category_day" :class="{'is-invalid': errors.category_day }" id="updateCategoryDay" :readonly="!editDebt">
                <span v-if="errors.category_day" class="invalid-feedback">
                    <strong>{{ errors.category_day ? errors.category_day[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="UpdateDelayCreditDay" class="col-form-label">{{ $t('debts.delay_credit_day') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.delay_credit_day" :class="{'is-invalid': errors.delay_credit_day }" id="UpdateDelayCreditDay" :readonly="!editDebt">
                <span v-if="errors.delay_credit_day" class="invalid-feedback">
                    <strong>{{ errors.delay_credit_day ? errors.delay_credit_day[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <label for="UpdateRegistryDate" class="col-form-label">{{ $t('debts.registry_date') }}</label>
                <input type="date" class="form-control" v-model="adminDebt.registry_date" :class="{'is-invalid': errors.registry_date }" id="UpdateRegistryDate" :readonly="!editDebt">
                <span v-if="errors.registry_date" class="invalid-feedback">
                    <strong>{{ errors.registry_date ? errors.registry_date[0] : '' }}</strong>
                </span>
              </div>
              <div class="col">
                <label for="UpdateRegistryNumber" class="col-form-label">{{ $t('debts.registry_number') }}</label>
                <input type="text" class="form-control" v-model="adminDebt.registry_number" :class="{'is-invalid': errors.registry_number }" id="UpdateRegistryNumber" :readonly="!editDebt">
                <span v-if="errors.registry_number" class="invalid-feedback">
                    <strong>{{ errors.registry_number ? errors.registry_number[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col">
                <div class="float-right">
                  <button type="submit" class="btn btn-primary" v-if="editDebt">
                    <i class="fa fa-save" v-if="!isProcessing"></i> <i class="fa fa-spinner fa-pulse" v-if="isProcessing"></i> {{ $t('buttons.save') }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      editDebt: false,
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminDebt',
      'adminListUsers',
      'adminListContragents',
      'adminListDebtStatuses',
    ]),
  },
  mounted() {
    this.GET_ADMIN_DEBT(this.$route.params.id);
    this.GET_ADMIN_LIST_DEBT_STATUSES();
    this.GET_ADMIN_LIST_CONTRAGENTS();
    this.GET_ADMIN_LIST_USERS();
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_USERS',
      'GET_ADMIN_LIST_CONTRAGENTS',
      'GET_ADMIN_LIST_DEBT_STATUSES',
      'GET_ADMIN_DEBT',
      'UPDATE_ADMIN_DEBT',
    ]),

    handleEditDebt() {
      if (this.editDebt) {
        this.editDebt = false;
      } else {
        this.editDebt = true;
      }
    },

    updateDebt() {
      this.isProcessing = true;
      this.UPDATE_ADMIN_DEBT(this.adminDebt)
        .then(() => {
          this.GET_ADMIN_DEBT(this.$route.params.id);
          this.editDebt = false;
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
